module.exports = {
  messages: {
    NETWORK_LOGGED_OUT_DIRECT_CONNECTIONS_CTA: 'Profil ansehen',
    NETWORK_LOGGED_OUT_DIRECT_CONNECTIONS_HEADLINE:
      'Lust auf Jobs im Home-Office?',
    NETWORK_LOGGED_OUT_DIRECT_CONNECTIONS_INDUSTRY_CONSTRUCTION: 'Baugewerbe',
    NETWORK_LOGGED_OUT_DIRECT_CONNECTIONS_INDUSTRY_CONSULTING:
      'Beratung / Consulting, IT & Softwareentwicklung',
    NETWORK_LOGGED_OUT_DIRECT_CONNECTIONS_INDUSTRY_DESCRIPTION: 'Sucht für',
    NETWORK_LOGGED_OUT_DIRECT_CONNECTIONS_INDUSTRY_INSURANCE: 'Versicherungen',
    NETWORK_LOGGED_OUT_DIRECT_CONNECTIONS_INDUSTRY_INTERNET_IT: 'Internet & IT',
    NETWORK_LOGGED_OUT_DIRECT_CONNECTIONS_INDUSTRY_IT_SECURITY: 'IT Security',
    NETWORK_LOGGED_OUT_DIRECT_CONNECTIONS_INDUSTRY_MECHANICAL_ENGINEERING:
      'Industrie & Ingenieurwesen',
    NETWORK_LOGGED_OUT_DIRECT_CONNECTIONS_INDUSTRY_ONLINE_MEDIA:
      'Internet & Online-Medien',
    NETWORK_LOGGED_OUT_DIRECT_CONNECTIONS_INDUSTRY_SOFTWARE: 'Software',
    NETWORK_LOGGED_OUT_DIRECT_CONNECTIONS_INDUSTRY_TELECOMMUNICATION:
      'Telekommunikation',
    NETWORK_LOGGED_OUT_DIRECT_CONNECTIONS_LINK: 'Alle ansehen',
    NETWORK_LOGGED_OUT_DIRECT_CONNECTIONS_SUBLINE:
      'Vernetz Dich direkt mit Leuten, die solche Jobs anbieten:',
    NETWORK_LOGGED_OUT_DIRECT_CONNECTIONS_TAG: 'Stellt ein',
    NETWORK_LOGGED_OUT_DISCOVER_CTA: 'Gleich loslegen',
    NETWORK_LOGGED_OUT_DISCOVER_HEADLINE:
      'Knüpfe wertvolle Kontakte für Deine Job-Suche',
    NETWORK_LOGGED_OUT_GET_DISCOVERED_CTA: 'Jetzt anmelden',
    NETWORK_LOGGED_OUT_GET_DISCOVERED_HEADLINE:
      'Mit einem XING Profil hast Du alle Chancen, von HR-Profis entdeckt zu werden.',
    NETWORK_LOGGED_OUT_HIRING_CTA: 'Job-Kriterien hinzufügen',
    NETWORK_LOGGED_OUT_HIRING_HEADLINE: 'Selbst auf Talent-Suche?',
    NETWORK_LOGGED_OUT_HIRING_SUBLINE:
      'Dann sag’s auf XING. Und hol die guten Leute an Bord.',
    NETWORK_LOGGED_OUT_TOP_RECRUITERS_HEADLINE: 'HR-Profis auf XING',
    NETWORK_LOGGED_OUT_TOP_RECRUITERS_SUBLINE:
      'Mit offenen Positionen bei angesagten Unternehmen',
  },
};
